
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/multiple-Portal.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"multiple-Portal","toc":"menu","filename":"docs/demo/multiple-Portal.md","lastUpdated":1674027995000,"nav":{"title":"Demo","path":"/demo"}};